import {Controller} from "@hotwired/stimulus";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        hideClearButton: Boolean,
    }

    initialize() {
        this._onPreConnect = this._onPreConnect.bind(this);
    }

    tomselect = null;

    connect() {
        this.element.addEventListener('autocomplete:pre-connect', this._onPreConnect);
        this.element.addEventListener('autocomplete:connect', this._onConnect);
    }

    disconnect() {
        this.element.removeEventListener('autocomplete:pre-connect', this._onPreConnect);
        this.element.removeEventListener('autocomplete:connect', this._onConnect);
        this.tomselect = null;
    }

    _onPreConnect(event) {
        if (this.hideClearButtonValue) {
            delete event.detail.options.plugins.clear_button;
        }

        event.detail.options.render = {
            ...event.detail.options.render,
            option: function (item) {
                return `
                    <div>
                        ${item.text}
                    </div>
                `;
            },
            item: function (item) {
                return `
                    <div>
                        ${item.text}
                    </div>
                `;
            },
            no_more_results: () => {
                return null;
            },
            loading_more: () => {
                return `<div class="loading-more-results">${translations['payments.filter.Loading more results']} ...</div>`;
            },
        };
    }

    _onConnect(event) {
        this.tomselect = event.detail.tomSelect;
    }
}
